import React, { useEffect } from 'react';
import propTypes from 'prop-types';
import _find from 'lodash/find.js';
import _get from 'lodash/get.js';
import classNames from 'classnames';
import { CORE_GTM_TRACKING_VALUES } from '_ui-core-js//constants/analytics.js';
import { fireGTMTrackingEvent } from '_ui-core-js/utilities/fireGTMTrackingEvent.js';
import { LBX_GTM_TRACKING_VALUES } from '../../constants/analytics.js';
import { LbxTheme, AtmosphereHero } from '../../partials';

const gtmComponentGroup = CORE_GTM_TRACKING_VALUES.componentGroup.newCars;
const gtmComponentName = LBX_GTM_TRACKING_VALUES.componentName.lbxStyleSelector;

export function RecommendationsScreen(props) {

  const { block, state, data, user } = props;
  const { model, subtitle, link, copy, labels, atmospheres } = data;
  const { 
    token, 
    saveUserData, 
    userPreferences, 
    setUserPreferences, 
    locale, 
    isUserLoggedIn, 
    setQuizResults,
    setGuestExpiryTime
  } = user;
  const activeAtmosphereData = _find(atmospheres, { atmosphere: state.recommendedAtmosphere });
  const { images, atmosphere, carColors, localName } = activeAtmosphereData;
  const activeCarImageObj = _find(carColors, (carColorObj) => (carColorObj.code || carColorObj.image.colorCode) === state.carColor);
  const activeCarImageUrl = activeCarImageObj.images[0].url || activeCarImageObj.images[0].image;
  const atmosphereHeroImages = [images[0], { base: activeCarImageUrl }, images[2]];

  useEffect(() => {
    if (isUserLoggedIn) {
      saveRecommendationToCustomerPortal();
    } else {
      storeRecommendationinLocalStorage();
    }
  }, []);

  useEffect(() => {
    fireGTMTrackingEvent({
      name: CORE_GTM_TRACKING_VALUES.name.workflowEvent,
      componentName: gtmComponentName, 
      componentGroup: gtmComponentGroup,
      action: CORE_GTM_TRACKING_VALUES.action.workflowStep,
      label: `${CORE_GTM_TRACKING_VALUES.label.resultScreen}/${state.recommendedAtmosphere}`
    }, {
      workflow: {
        name: LBX_GTM_TRACKING_VALUES.componentName.lbxStyleSelector,
        step: `${CORE_GTM_TRACKING_VALUES.label.resultScreen}/${state.recommendedAtmosphere}`,
        conversion: 1,
        variant: user.userPreferences && user.userPreferences.personality ? user.userPreferences.personality : CORE_GTM_TRACKING_VALUES.label.general
      }
    });
  }, []);

  function getQuizResults () {
    return  { 
      personality: state.yourNature,
      atmosphere: state.recommendedAtmosphere,
      keywords: state.keywords,
      colour: state.carColor
    };
  };

  async function saveRecommendationToCustomerPortal () {
    const results = getQuizResults();

    const payload = {
      ...userPreferences,
      ...results
    };

    saveUserData({token, payload, setUserPreferences, locale});
    setCanRenderPersonalPage(false);
		setAllowGuestAccess(false);
    setGuestExpiryTime(null)
  }

  function storeRecommendationinLocalStorage () {
    const results = getQuizResults();

    const currentTime = Date.now();
    const fiveMinutesfromNow = currentTime + 5 * 60 * 1000;

    setUserPreferences(results);
		setGuestExpiryTime(fiveMinutesfromNow)
    setQuizResults(results);
  }

  return (
    <LbxTheme 
    theme={state.recommendedAtmosphere}
    className={classNames({
      [`${block}__screen-container`]: true, 
      [`${block}__screen-container--${state.activeView}`]: true,
      'utils__section-padding--uniform': true
    })}
    >
      <div className='container-xxxl'>
        {
          activeAtmosphereData &&
            <AtmosphereHero 
            model={model}
            subtitle={subtitle}
            copy={copy}
            link={link}
            atmosphere={localName || atmosphere}
            images={atmosphereHeroImages}
            carColors={carColors}
            initColorCode={state.carColor}
            labels={labels}
            />
        }
      </div>
    </LbxTheme>
  )
};

RecommendationsScreen.propTypes = {
  block: propTypes.string.isRequired,
  state: propTypes.object.isRequired,
  rootElRef: propTypes.object.isRequired,
  data: propTypes.object.isRequired
};